import { gql } from 'apollo-boost';

export default gql`
  mutation grocerySuspendedOrderStatus($input: GroceryOrderPauseDateInput!) {
    grocerySuspendedOrderStatus(input: $input)
  }
`;
